<template>
  <RxkDialog
    title="导入任务"
    width="1000px"
    v-model="showVisible"
    @close="close"
    @sure="close"
    class="upload_log_dialog"
  >
    <div class="import-dialog">
      <div class="search-content">
        <div class="search-item">
          <span class="item-label">导入时间：</span>
          <el-date-picker
            v-model="time"
            class="date-picker"
            type="datetimerange"
            value-format="YYYY-MM-DD HH:mm:ss"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          />
        </div>
        <RxkButton type="primary" class="search-btn" @click="handleSearch">搜索</RxkButton>
      </div>
      <div class="s-table-box">
        <RxkVTable ref="vacanzeTable" @register="registerTable" />
      </div>
    </div>
    <WarnTipDialog
      v-model:showWarnTip="showOperateTipDialog"
      :warnTipInfo="operateTip"
      @handleConfirmBtn="handleConfirm"
      @handleCancelBtn="
        () => {
          showOperateTipDialog = false
          record = null
        }
      "
    />
  </RxkDialog>
</template>

<script setup lang="tsx">
import { unref, computed, ref, watch } from 'vue'
import { RxkDialog } from '@/components/common/RxkDialog'
import WarnTipDialog from '@/components/restructure/warnTipDialog/index.vue'
import { RxkVTable } from '@/components/common/RxkVTable'
import { useTable } from '@/components/common/RxkVTable/src/hooks/useTable'
import { RxkButton } from '@/components/common/RxkButton'

import { ElMessage } from 'element-plus'
import type { ColumnType } from '@/types/table'

import { useTemCache } from '@/stores/modules/temCache'
const temCache = useTemCache()
import { getImportList, downFailResultApi, fileDelete } from '@/apis/import'
const emit = defineEmits(['update:visible'])
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})
const showVisible = computed({
  get() {
    return props.visible
  },
  set(v) {
    console.log(v, '123')

    emit('update:visible', v)
  }
})
const time = ref('')
const columns: ColumnType[] = [
  {
    key: 'tableName',
    title: '导入类型',
    width: 80
  },
  {
    key: 'fileName',
    title: '导入文件名',

    showOverflow: true
  },
  {
    key: 'createTime',
    title: '导入时间',

    showOverflow: true
  },
  {
    key: 'remark',
    title: '导入结果',
    showOverflow: true
  },
  {
    key: 'importUserName',
    title: '操作人',
    width: 100,
    showOverflow: true
  },
  {
    key: 'operates',
    title: '操作',
    fixed: 'right',
    width: 160,
    render: data => {
      const { cellData } = data
      return (
        <>
          {[20, 40].includes(cellData.status) && (
            <span class="tw-text-[#5687FF] tw-cursor-pointer" onClick={() => download(cellData)}>
              下载失败数据{' '}
            </span>
          )}
          {[10, 20, 40, 100].includes(cellData.status) && (
            <span
              class="tw-ml-[4px] tw-text-[#5687FF] tw-cursor-pointer"
              onClick={() => deleteRecord(cellData)}
            >
              删除{' '}
            </span>
          )}
        </>
      )
    }
  }
]
const operateTip = ref({
  title: '操作确认',
  width: '410px',
  cancelButtonText: '取消',
  sureButtonText: '确定',
  descContent: '',
  mainContent: '当前页面内容未保存，确认离开？'
})
const showOperateTipDialog = ref(false)
const record = ref<Record<string, string> | null>(null)
const download = (data: any) => {
  downFailResultApi(data.id)
}
const deleteRecord = (data: any) => {
  operateTip.value.mainContent = '删除后数据无法恢复，确定要删除吗？'
  showOperateTipDialog.value = true
  record.value = data
}
const handleConfirm = () => {
  fileDelete(record.value?.id).then(() => {
    ElMessage({
      message: '操作成功',
      type: 'success'
    })
    showOperateTipDialog.value = false
    reload()
  })
}
watch(
  () => showVisible.value,
  e => {
    e && reload()
  }
)
const [registerTable, { reload, setSearchInfo }] = useTable({
  api: getImportList,
  columns: getBasicColumns(),
  immediate: true, // 是否立刻请求
  showRowIndex: false,
  showSelection: false
})
const handleSearch = () => {
  setSearchInfo({
    model: { startTime: unref(time)?.[0], endTime: unref(time)?.[1] }
  })
  reload()
}
function getBasicColumns(): ColumnType[] {
  return unref(columns)
}
function close() {
  console.log('guanbi')
  emit('update:visible', false)
  temCache.saveData('showImportTask', false)
}
</script>
<style scoped lang="scss">
.import-dialog {
  @include flex-center(column, flex-start, normal);
  width: 100%;
  height: 600px;
  overflow: auto;

  .s-table-box {
    flex: 1;

    :deep(.c-el-table) {
      .el-table {
        width: calc(100% - 48px) !important;
        margin: 0 auto;

        th {
          &:nth-child(1) {
            border-left: 1px solid rgba(227, 229, 242, 0.8);
          }

          &:nth-last-child(2),
          &:nth-last-child(1) {
            border-right: 1px solid rgba(227, 229, 242, 0.8) !important;
          }
        }

        .el-table__row {
          td {
            &:nth-child(1) {
              border-left: 1px solid rgba(227, 229, 242, 0.8);
            }
          }
        }
      }
    }
  }

  .pagination-box {
    padding-right: 20px;
    border-top: 1px solid #e9e9e9;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .search-content {
    margin: 24px 0 16px;
    padding: 0 24px;
    @include flex-center(row, flex-start);
    flex-wrap: wrap;

    .item-label {
      font-size: 13px;
      color: #666666;
    }

    .date-picker {
      width: 240px;
    }

    .search-btn {
      margin-left: 8px;
    }
  }
}
</style>
<style lang="scss">
.upload_log_dialog {
  .el-dialog__footer {
    border-top: 1px solid #ebeef5;
  }
}
</style>
